import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
function GoogleMaterialIcon({ icon, filled = false, fontSize = 'small', customSize, style = {}, sx, ...other }) {
    return (
        <Icon
            fontSize={fontSize}
            baseClassName={`material-symbols-rounded googleIcon ${filled ? "filled" : ""}`}
            sx={{
                ...sx,
                ...(customSize && { fontSize: customSize })  // customSize overrides fontSize
            }}
            style={{ fontSize: customSize || undefined, ...style }}
            {...other}
        >
            {icon}
        </Icon>
    );
}
GoogleMaterialIcon.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.string]),
    filled: PropTypes.bool,
    fontSize: PropTypes.oneOf(['small', 'medium', 'large', 'inherit']),
    customSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // e.g., "30px" or 30
    sx: PropTypes.object,
    style: PropTypes.object,
};
export default GoogleMaterialIcon;